import { deleteAlarmType } from "actions/Utilities/AlarmType";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { alarmTypeReFetching } from "../atoms/atoms";

export default function useDeleteAlarmType() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    alarmTypeReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteAlarmType(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Alarm Type failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Alarm Type Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Alarm Type Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Alarm Type failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Alarm Type not found":
              toast.fire(
                "Disabling Alarm Type failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Alarm Type failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Alarm Type failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
